import WorkforceHero from "./WorkforceHero";
import WorkforceJiviews from "./WorkforceJiviews";
import WorkforceCore from "./WorkforceCore";
import WorkforceBenefits from "./WorkforceBenefits";
import WorkforceIntelligence from "./WorkforceIntelligence";

const Workforce = () => {
  return (
    <>
      <WorkforceHero />
      <WorkforceJiviews />
      <WorkforceCore />
      <WorkforceBenefits />
      <WorkforceIntelligence />
    </>
  );
};

export default Workforce;